var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonumentHistoireChateau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n      stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.74,19.76H14.26l-3.69,42.7h11.16v-14.85c0-5.7,4.66-10.35,10.35-10.35h0c5.7,0,10.35,4.66,10.35,10.35v14.77h11.16l-3.85-42.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.59,17.59l1.61-16.05h-5.86v2.01c0,1.93-1.52,3.45-3.45,3.45s-3.45-1.52-3.45-3.45V1.54h-6.98v2.01c0,1.93-1.52,3.45-3.45,3.45h0c-1.93,0-3.45-1.52-3.45-3.45V1.54h-6.98v2.01c0,1.93-1.52,3.45-3.45,3.45h0c-1.93,0-3.45-1.52-3.45-3.45V1.54h-5.86l1.61,16.05h43.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonumentHistoireChateau);
export default __webpack_public_path__ + "static/media/monument-histoire-chateau.63b032fd0f6949d1d4f891460fb2b04c.svg";
export { ForwardRef as ReactComponent };